import styled from "styled-components";
import "../../index.scss";

export const AdBlockDiv = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	align-items: center;
	justify-content: center;
	text-align: center;
	flex-direction: column;
	img {
		width: 400px;
		object-fit: cover;
		height: 105px;
	}

	div {
		text-align: left;
		padding-top: 20px;
		border-top: 1px solid;
	}
`;
